import { clsx } from 'clsx';
import { Flex } from '@nula/core-ui';
import type { Proposal } from '@/lib/templates/api';
import type { TextReview } from '../hooks/use-text-review';
import { SurfaceReviewCard } from './surface-review-card';
import styles from './surface-review-cards.module.css';

interface SurfaceReviewCardsProps {
  proposal: Proposal;
  review: TextReview;
  currentKey?: string | null;
  slotRef?: (key: string, el: HTMLElement | null) => void;
  onSlotFocus?: (key: string) => void;
}

export function SurfaceReviewCards({ proposal, review, currentKey, slotRef, onSlotFocus }: SurfaceReviewCardsProps) {
  return (
    <Flex vertical className={styles.column}>
      {proposal.sections.map((section) => {
        const current = section.key === currentKey;
        return (
          <Flex
            key={section.key}
            ref={(el: HTMLElement | null) => slotRef?.(section.key, el)}
            role="group"
            aria-label={section.heading}
            aria-current={current ? 'true' : undefined}
            tabIndex={-1}
            data-testid="review-card"
            className={clsx(styles.slot, current && styles.current)}
            onFocus={() => onSlotFocus?.(section.key)}
          >
            <SurfaceReviewCard section={section} state={review.state} review={review} />
          </Flex>
        );
      })}
    </Flex>
  );
}
